export enum TrafficLogReportType {
  Daily = 'Daily',
  Weekly = 'Weekly',
  Monthly = 'Monthly',
}

export const trafficLogReportTypeMap: Record<TrafficLogReportType, string> = {
  [TrafficLogReportType.Daily]: 'Daily',
  [TrafficLogReportType.Weekly]: 'Weekly',
  [TrafficLogReportType.Monthly]: 'Monthly',
};

export const trafficLogReportTypeOptions = [
  { value: TrafficLogReportType.Daily, label: trafficLogReportTypeMap[TrafficLogReportType.Daily] },
  { value: TrafficLogReportType.Weekly, label: trafficLogReportTypeMap[TrafficLogReportType.Weekly] },
  { value: TrafficLogReportType.Monthly, label: trafficLogReportTypeMap[TrafficLogReportType.Monthly] },
];
